import {createSlice} from "@reduxjs/toolkit";

const initialState = {
    isWorkforceCaseEditable: false,
    workforceCaseDetails: {},
    createWorkforceCaseDetails: {},
    editWorkforceCaseDetails: {},
    removedAttachmentUrls: [],
    attachmentUrls: []
};

export const workforceSlice = createSlice({
    name: "workforce",
    initialState,
    reducers: {
        SET_IS_WORKFORCE_CASE_EDITABLE: (state, {payload}) => {
            state.isWorkforceCaseEditable = payload;
        },

        SET_WORKFORCE_CASE_DETAILS: (state, {payload}) => {
            state.workforceCaseDetails = payload;
        },

        SET_CREATE_WORKFORCE_CASE_DETAILS: (state, {payload}) => {
            state.createWorkforceCaseDetails = payload
        },
        SET_EDIT_WORKFORCE_CASE_DETAILS: (state, {payload}) => {
            state.editWorkforceCaseDetails = payload
        },
        SET_REMOVED_ATTACHMENT_URLS: (state, {payload}) => {
            state.removedAttachmentUrls = payload
        },
        SET_WORKFORCE_CASE_ATTACHMENT_URLS: (state, {payload}) => {
            state.attachmentUrls = payload
        },
    },
});

export const {
    SET_IS_WORKFORCE_CASE_EDITABLE,
    SET_WORKFORCE_CASE_DETAILS,
    SET_CREATE_WORKFORCE_CASE_DETAILS,
    SET_EDIT_WORKFORCE_CASE_DETAILS,
    SET_REMOVED_ATTACHMENT_URLS,
    SET_WORKFORCE_CASE_ATTACHMENT_URLS
} = workforceSlice.actions;

export default workforceSlice.reducer;